import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import { css, StyleSheet } from "aphrodite";
import Link from "next/link";
import { FC } from "react";

type Props = {
  itemType: string;
};

const NotFound: FC<Props> = (props: Props) => {
  const { itemType } = props;
  return (
    <div className={css(styles.loadingError)}>
      <img
        src="/images/not-found.png"
        alt="not-found"
        className={css(styles.errorImage)}
      />
      <h2 className={css(styles.title)}>That {itemType} does not exist</h2>
      <p className={css(styles.subtitle)}>
        <Link href="/" className={css(styles.link)}>
          Go home
        </Link>
      </p>
    </div>
  );
};

export default NotFound;

const styles = StyleSheet.create({
  loadingError: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: deprecatedTones.blue2,
  },
  title: {
    fontWeight: 400,
    marginBottom: 0,
  },
  subtitle: {
    width: "300px",
    fontWeight: 300,
    color: deprecatedTones.gray11Alpha,
  },
  link: {
    color: deprecatedTones.blue11,
    textDecoration: "none",
  },
  errorImage: {
    overflow: "hidden",
  },
});
